import {
  Companion_getInstance2aw7vbmm2h3t7 as Companion_getInstance,
  LineItemDispute2w87ksbqzbvuq as LineItemDispute,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_itemId(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItemDispute_itemId_getInstance());
}
function prepareLineItemDisputeFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [LineItemDispute_itemId_getInstance(), LineItemDispute_sourceMessage_getInstance(), LineItemDispute_lineItemOnly_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function LineItemDispute_itemId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function LineItemDispute_itemId$_get_name_$ref_rsn2qr() {
  return (p0) => p0.k20();
}
function LineItemDispute_itemId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemDispute_itemId$_get_serializer_$ref_4qytvo() {
  return (p0) => p0.j2j();
}
function LineItemDispute_itemId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function LineItemDispute_itemId$_get_annotations_$ref_l9gou0() {
  return (p0) => p0.bz();
}
var LineItemDispute_itemIdClass;
function LineItemDispute_itemId() {
  if (LineItemDispute_itemIdClass === VOID) {
    class $ {
      constructor() {
        LineItemDispute_itemId_instance = this;
        var tmp = this;
        tmp.h6j_1 = lazy(LineItemDispute_itemId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i6j_1 = lazy(LineItemDispute_itemId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j6j_1 = lazy(LineItemDispute_itemId$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemDispute_itemId$_get_name_$ref_rsn2qr(), null);
        return tmp0.f2();
      }
      k6j(receiver) {
        return receiver.l6j_1;
      }
      m2j(receiver) {
        return this.k6j(receiver instanceof LineItemDispute() ? receiver : THROW_CCE());
      }
      o6j(receiver, value) {
        return receiver.p6j(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof LineItemDispute() ? receiver : THROW_CCE();
        return this.o6j(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemDispute_itemId$_get_serializer_$ref_4qytvo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemDispute_itemId$_get_annotations_$ref_l9gou0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemDispute_itemId', VOID, VOID, [SerializableProperty()]);
    LineItemDispute_itemIdClass = $;
  }
  return LineItemDispute_itemIdClass;
}
var LineItemDispute_itemId_instance;
function LineItemDispute_itemId_getInstance() {
  if (LineItemDispute_itemId_instance === VOID)
    new (LineItemDispute_itemId())();
  return LineItemDispute_itemId_instance;
}
function LineItemDispute_sourceMessage$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function LineItemDispute_sourceMessage$_get_name_$ref_njaeyf() {
  return (p0) => p0.k20();
}
function LineItemDispute_sourceMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemDispute_sourceMessage$_get_serializer_$ref_10ah3y() {
  return (p0) => p0.j2j();
}
function LineItemDispute_sourceMessage$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function LineItemDispute_sourceMessage$_get_annotations_$ref_noe92a() {
  return (p0) => p0.bz();
}
var LineItemDispute_sourceMessageClass;
function LineItemDispute_sourceMessage() {
  if (LineItemDispute_sourceMessageClass === VOID) {
    class $ {
      constructor() {
        LineItemDispute_sourceMessage_instance = this;
        var tmp = this;
        tmp.q6j_1 = lazy(LineItemDispute_sourceMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r6j_1 = lazy(LineItemDispute_sourceMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s6j_1 = lazy(LineItemDispute_sourceMessage$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemDispute_sourceMessage$_get_name_$ref_njaeyf(), null);
        return tmp0.f2();
      }
      k6j(receiver) {
        return receiver.m6j_1;
      }
      m2j(receiver) {
        return this.k6j(receiver instanceof LineItemDispute() ? receiver : THROW_CCE());
      }
      o6j(receiver, value) {
        return receiver.p6j(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof LineItemDispute() ? receiver : THROW_CCE();
        return this.o6j(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemDispute_sourceMessage$_get_serializer_$ref_10ah3y(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemDispute_sourceMessage$_get_annotations_$ref_noe92a(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemDispute_sourceMessage', VOID, VOID, [SerializableProperty()]);
    LineItemDispute_sourceMessageClass = $;
  }
  return LineItemDispute_sourceMessageClass;
}
var LineItemDispute_sourceMessage_instance;
function LineItemDispute_sourceMessage_getInstance() {
  if (LineItemDispute_sourceMessage_instance === VOID)
    new (LineItemDispute_sourceMessage())();
  return LineItemDispute_sourceMessage_instance;
}
function LineItemDispute_lineItemOnly$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function LineItemDispute_lineItemOnly$_get_name_$ref_ku1w2m() {
  return (p0) => p0.k20();
}
function LineItemDispute_lineItemOnly$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItemDispute_lineItemOnly$_get_serializer_$ref_t9yvw7() {
  return (p0) => p0.j2j();
}
function LineItemDispute_lineItemOnly$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function LineItemDispute_lineItemOnly$_get_annotations_$ref_vx4bgz() {
  return (p0) => p0.bz();
}
var LineItemDispute_lineItemOnlyClass;
function LineItemDispute_lineItemOnly() {
  if (LineItemDispute_lineItemOnlyClass === VOID) {
    class $ {
      constructor() {
        LineItemDispute_lineItemOnly_instance = this;
        var tmp = this;
        tmp.t6j_1 = lazy(LineItemDispute_lineItemOnly$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u6j_1 = lazy(LineItemDispute_lineItemOnly$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v6j_1 = lazy(LineItemDispute_lineItemOnly$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItemDispute_lineItemOnly$_get_name_$ref_ku1w2m(), null);
        return tmp0.f2();
      }
      k6j(receiver) {
        return receiver.n6j_1;
      }
      m2j(receiver) {
        return this.k6j(receiver instanceof LineItemDispute() ? receiver : THROW_CCE());
      }
      w6j(receiver, value) {
        return receiver.p6j(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof LineItemDispute() ? receiver : THROW_CCE();
        return this.w6j(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItemDispute_lineItemOnly$_get_serializer_$ref_t9yvw7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItemDispute_lineItemOnly$_get_annotations_$ref_vx4bgz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItemDispute_lineItemOnly', VOID, VOID, [SerializableProperty()]);
    LineItemDispute_lineItemOnlyClass = $;
  }
  return LineItemDispute_lineItemOnlyClass;
}
var LineItemDispute_lineItemOnly_instance;
function LineItemDispute_lineItemOnly_getInstance() {
  if (LineItemDispute_lineItemOnly_instance === VOID)
    new (LineItemDispute_lineItemOnly())();
  return LineItemDispute_lineItemOnly_instance;
}
//region block: exports
export {
  get_itemId as get_itemIdfkyjzwbz0fug,
  prepareLineItemDisputeFields as prepareLineItemDisputeFields1qk8n0mnxy06m,
};
//endregion

//# sourceMappingURL=LineItemDisputeFields.mjs.map
